var SCM = SCM || {};

SCM.ToolboxGetCitations = (function ($) {
    var dataService;

    return {
        init: init,
        updateAddToCMButton: updateAddToCMButton
    };

    function init() {
        if (!$('.js-add-to-citation-download-manager').length && !$('.js-bulk-citation-manager-add').length) {
            return;
        }

        dataService = SCM.ToolboxGetCitations.DataService;
        bindUiEvents();
        disableResourcesAlreadyInCM();
    }

    function bindUiEvents() {
        var $delegateElement = $('#main');
        $delegateElement.on('click', '.js-add-to-citation-download-manager',
            function () {
                var $this = $(this);
                addToCitationDownloadManager($this);
            }
        );

        $delegateElement.on('change', '.js-checkBoxClass', handleResourceCheckBoxChange);

        $delegateElement.on('click', '.js-bulk-citation-manager-add', handleBulkAddToCitationManager);

        $delegateElement.on('click', '.js-bulk-citation-manager-add-issue', handleIssueBulkAddToCitationManager);

    }

    function anyResourcesSelected($section) {
        return selectedResourcesInSection($section).length;
    }

    function handleResourceCheckBoxChange(e) {
        var $parentSection = $(e.currentTarget)
            .closest('section');
        $parentSection.find('.js-bulk-citation-manager-add')
            .prop('disabled', !anyResourcesSelected($parentSection));

        var $issueSection = $('.section-container');
        $('.js-bulk-citation-manager-add-issue').prop('disabled', !anyResourcesSelected($issueSection));
    }

    function selectedResourcesInSection($section) {
        return $section.find('.js-checkBoxClass:checked')
            .map(function (i, resourceCheckBox) {
                return {
                    id: $(resourceCheckBox).data('resourceId'),
                    typeid: $(resourceCheckBox).data('resourceTypeId')
                };
            })
            .get();
    }

    function disableResourcesAlreadyInCM() {
        dataService.getResourceIdsAlreadyInCitationManager()
            .then(function (resources) {
                $('.js-add-to-citation-download-manager').each(function () {
                    var $this = $(this);
                    var resourceId = $this.data('resourceId');
                    var resourceType = $this.data('resourceTypeId');
                    var resource = resourceId + '-' + resourceType;

                    if (resources.indexOf(resource) > -1) {
                        $this.data('inCitationManager', 'true');
                        $this.addClass('disabled');
                    }
                });
            });
    }

    function addToCitationDownloadManager($addToCmButton) {
        if ($addToCmButton.hasClass('disabled')) return;
        var resourceId = $addToCmButton.data('resourceId');
        var resourceType = $addToCmButton.data('resourceTypeId');

        dataService.addResourceToCitationManager(resourceId, resourceType);
    }

    function handleBulkAddToCitationManager(e) {
        var $parentSection = $(e.currentTarget)
            .closest('section');
        var selectedResources = selectedResourcesInSection($parentSection);
        filterAndAddResourcesToCitationManager(selectedResources);

        return;
    }


    function handleIssueBulkAddToCitationManager(e) {
        var selectedResources = selectedResourcesInSection($('.section-container'));
        filterAndAddResourcesToCitationManager(selectedResources);

        return;
    }

    function filterAndAddResourcesToCitationManager(selectedResources) {
        if (!Array.isArray(selectedResources) || !selectedResources.length) {
            return;
        }
        dataService.getResourceIdsAlreadyInCitationManager()
            .then(function (resourceIdsInCM) {
                var resourcesToAddToCitationManager = selectedResources
                    .filter(function (resource) {
                        return !resourceIdsInCM.includes(resource.id);
                    });
                if (!resourcesToAddToCitationManager.length) {
                    alert('No selected resources can be added to your Citation Manager');
                    return;
                }
                addResourcesToCitationManager(resourcesToAddToCitationManager);
            })
            .catch(function (reason) {
                console.error('Failed to get resourceIds in cart.', reason);
            });
    }

    function addResourcesToCitationManager(resources) {
        dataService.addResourcesToCitationManager(resources)
            .then(function () {
                resources.forEach(function (resource) {
                    updateAddToCMButton(resource.id, resource.typeid);
                });
            })
            .catch(function (reason) {
                console.error('Failed to add resources to cart.', reason);
            });
    }

    function updateAddToCMButton(resourceId, resourceTypeId) {
        $('.js-add-to-citation-download-manager[data-resource-id=' + resourceId + '][data-resource-type-id=' + resourceTypeId + ']').addClass('disabled');
    }

})(jQuery);

SCM.ToolboxGetCitations.DataService = (function ($) {
    return {
        addResourceToCitationManager: addResourceToCitationManager,
        getResourceIdsAlreadyInCitationManager: getResourceIdsAlreadyInCitationManager,
        addResourcesToCitationManager: addResourcesToCitationManager
    };

    function addResourceToCitationManager(resourceId, resourceTypeId) {

        if (!resourceId || !resourceTypeId) return;

        $.ajax({
            type: 'POST',
            url: '/Citation/AddToCitationManagerAjax',
            dataType: 'text',
            data: {
                resourceId: resourceId,
                resourceTypeId: resourceTypeId
            }
        }).done(function (result) {
            result = JSON.parse(result);
            if (!result.Success) {
                console.error('Cannot add citation');
            }
            SCM.ToolboxGetCitations.updateAddToCMButton(resourceId, resourceTypeId);
        });
    }

    function addResourcesToCitationManager(resources) {
        if (!Array.isArray(resources) || !resources.length) {
            return Promise.reject('No resources provided');
        }

        var promises = [];
        resources.forEach(function (resource) {
            promises.push(addResourceToCitationManager(resource.id, resource.typeid));
        });

        return Promise.all(promises)
            .then(function (result) {
                return Array.isArray(result)
                    ? maxValue(result)
                    : result;
            });
    }

    function maxValue(numberArray) {
        return numberArray.sort(function (a, b) { return b - a; })
            .shift();
    }

    function getResourceIdsAlreadyInCitationManager() {
        return $.ajax({
            type: 'POST',
            url: '/Citation/GetResourcesInCitationManager',
            cache: false
        })
            .promise()
            .then(function (response) {
                if (!response.Success) {           
                    return Promise.reject('Action return non-success status');
                }

                if (!Array.isArray(response.Messages)) {
                    return Promise.reject('Action did not return expected response');
                }

                if (!response.Messages.length) {
                    return [];
                }

                return response.Messages[0].split(',');
            });
    }

})(jQuery);